/* eslint-disable @angular-eslint/component-selector */

import { Component, Input, OnInit } from '@angular/core';
import { Audit } from 'app/core/models/audit.model';
import { obj2Html } from '../../../core/lib/js-utils';
import { DatePipe } from '@angular/common';
import { BlankValueDashPipe } from '../../../shared/pipes/blank-value-dash.pipe';

@Component({
    selector: '[app-audit-provider-create-row]',
    templateUrl: './audit-provider-create-row.component.html',
    styleUrls: ['./audit-provider-create-row.component.scss'],
    imports: [DatePipe, BlankValueDashPipe]
})
export class AuditProviderCreateRowComponent implements OnInit {
  @Input() audit: Audit;
  newValueHtml;

  constructor() {}

  ngOnInit() {
    const {
      internalNotes, // eslint-disable-line unused-imports/no-unused-vars
      ...changes
    } = this.audit.auditedChanges;

    this.newValueHtml = obj2Html(changes);
  }
}
